import React from 'react'

function DropDownWindowStyle() {
  return (
    <style jsx='true'>
      {`
        /* DROPDOWN WINDOW */
        #dropdown-window {
          display: flex;
          flex-direction: column;
          margin: 0;
          /*position: absolute;*/
          /*border: solid 1px blue;*/
          border: none;
          background-color: white;
          /*font-size: 15px;*/
          /*width: 44.9%;*/
          width: 100%;
          color: rgba(33,33,33,1);
          box-sizing: border-box;
          /*margin-top: 33px;*/
          /*margin-left: 10%;*/
          /*margin-left: 137px;*/
          overflow: auto;
          max-height: 100px;
          z-index: 99;
          /*left: -10%;*/
          box-shadow: 1px 1px 2px 1px rgba(195, 195, 195, 1);
        }
        #dropdown-window .pospro-action-btn {
          font-size: 0.8rem;
          text-align: left;
        }
      `}
    </style>
  )
}

export default React.memo(DropDownWindowStyle)
